module.exports = __webpack_public_path__ + "static/media/avatar_libra_asegurados.62291189.png";